import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { LoadingSpinner } from '@ui/LoadingSpinner';
import { PardotPicklistValueList } from '@periscopes/general/pardot-picklist-values';
import { useApiResource } from '@hooks';
import { When } from 'react-if';
import { MetadataContainer } from '@periscopes/general/metadata';
import React, { useMemo } from 'react';
export const PardotFieldMetadataTab = ({ index, picklistValueCount, sonarObjectId }) => {
    const pardotFieldMetadataUri = `v3/pardot/fields/${sonarObjectId}/field-metadata`;
    const picklistPardotFieldUri = `v3/pardot/fields/${sonarObjectId}/picklist-field-metadata`;
    const { loading, resource } = useApiResource(pardotFieldMetadataUri);
    const { syncBehavior } = resource !== null && resource !== void 0 ? resource : {};
    const metadataEntries = useMemo(() => {
        const entries = [
            {
                label: COPY_SPECIFIC.SYNC_BEHAVIOR,
                type: 'string',
                value: syncBehavior
            }
        ];
        return entries;
    }, [syncBehavior]);
    if (loading) {
        return React.createElement(LoadingSpinner, { spinning: true });
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(MetadataContainer, { entries: metadataEntries, title: COPY_SPECIFIC.FIELD_INFORMATION }),
        React.createElement(When, { condition: picklistValueCount > 0 },
            React.createElement(PardotPicklistValueList, { parentIndex: index, uri: picklistPardotFieldUri }))));
};
